import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/ic-kontrol';

const SEV_RENK: Record<string, { bg: string; text: string; label: string }> = {
  yuksek: { bg: '#fee2e2', text: '#991b1b', label: '🔴 Yüksek' },
  orta:   { bg: '#fef3c7', text: '#92400e', label: '🟡 Orta'   },
  dusuk:  { bg: '#d1fae5', text: '#065f46', label: '🟢 Düşük'  },
  '':     { bg: '#f3f4f6', text: '#374151', label: '—'          },
};

const CEVAP_ETIKET: Record<string, string> = {
  kabul_et: 'Kabul Et', kontrol_et: 'Kontrol Et', devret: 'Devret', kacin: 'Kaçın',
};

const BOŞ: any = {
  isletme_id: '', birim_adi: '', risk_adi: '', risk_aciklamasi: '', hedef_adi: '',
  risk_turu: 'ic', risk_duzeyi: 'faaliyet', risk_kategorisi: 'operasyonel',
  dogal_olasilik: 5, dogal_etki: 5, mevcut_kontroller: '',
  cevap_yontemi: 'kontrol_et', cevap_aciklamasi: '',
  kalinti_olasilik: 3, kalinti_etki: 3,
  risk_sahibi_adi: '', notlar: '',
};

export default function IcKontrolRiskler() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const [riskler, setRiskler] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [filtre, setFiltre] = useState({ seviye: '', durum: '' });
  const [modal, setModal] = useState<'' | 'ekle' | 'eylem'>('');
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState({ ...BOŞ });
  const [eylemler, setEylemler] = useState<any[]>([]);
  const [eylemForm, setEylemForm] = useState({ eylem_adi: '', aciklama: '', sorumlu_adi: '', bitis_tarihi: '', tamamlanma_yuzdesi: 0 });
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const yukle = () => {
    const p: Record<string, string> = {};
    if (filtre.seviye) p.seviye = filtre.seviye;
    if (filtre.durum) p.durum = filtre.durum;
    const qs = new URLSearchParams(p).toString();
    fetch(`${API}/riskler${qs ? '?' + qs : ''}`, { headers })
      .then(r => r.json()).then(d => setRiskler(Array.isArray(d) ? d : []));
  };

  useEffect(() => {
    yukle();
    fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/isletmeler', { headers })
      .then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : []));
  }, [filtre]);

  const kaydet = async () => {
    setKaydediliyor(true);
    const url = secili ? `${API}/riskler/${secili.id}` : `${API}/riskler`;
    const method = secili ? 'PUT' : 'POST';
    const res = await fetch(url, { method, headers, body: JSON.stringify(form) });
    if (res.ok) { setModal(''); setSecili(null); setForm({ ...BOŞ }); yukle(); }
    setKaydediliyor(false);
  };

  const duzenle = (r: any) => {
    setSecili(r);
    setForm({ ...r });
    setModal('eylem');
    // Eylemlerini yükle
    fetch(`${API}/riskler/${r.id}/eylemler`, { headers })
      .then(res => res.json()).then(d => setEylemler(Array.isArray(d) ? d : []));
  };

  const riskSil = async (id: number) => {
    if (!confirm('Bu riski silmek istediğinizden emin misiniz?')) return;
    await fetch(`${API}/riskler/${id}`, { method: 'DELETE', headers });
    yukle();
  };

  const eylemEkle = async () => {
    if (!secili || !eylemForm.eylem_adi) return;
    await fetch(`${API}/riskler/${secili.id}/eylemler`, {
      method: 'POST', headers, body: JSON.stringify(eylemForm)
    });
    setEylemForm({ eylem_adi: '', aciklama: '', sorumlu_adi: '', bitis_tarihi: '', tamamlanma_yuzdesi: 0 });
    fetch(`${API}/riskler/${secili.id}/eylemler`, { headers })
      .then(r => r.json()).then(d => setEylemler(Array.isArray(d) ? d : []));
  };

  const dogalPuan = Number(form.dogal_olasilik) * Number(form.dogal_etki);
  const kalintiPuan = Number(form.kalinti_olasilik) * Number(form.kalinti_etki);

  const pRenk = (p: number) => p >= 50 ? '#fee2e2' : p >= 25 ? '#fef3c7' : '#d1fae5';
  const pYazi = (p: number) => p >= 50 ? '#991b1b' : p >= 25 ? '#92400e' : '#065f46';

  return (
    <div style={{ padding: '24px', maxWidth: 1300 }}>
      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, color: '#111827' }}>⚠️ Risk Yönetimi</h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
            5. Standart: Planlama ve Programlama • 6. Standart: Risklerin Belirlenmesi ve Değerlendirilmesi
          </p>
        </div>
        <button onClick={() => { setSecili(null); setForm({ ...BOŞ }); setModal('ekle'); }} style={{
          background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14
        }}>+ Yeni Risk</button>
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <select value={filtre.seviye} onChange={e => setFiltre(f => ({ ...f, seviye: e.target.value }))}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Seviyeler</option>
          <option value="yuksek">🔴 Yüksek</option>
          <option value="orta">🟡 Orta</option>
          <option value="dusuk">🟢 Düşük</option>
        </select>
        <select value={filtre.durum} onChange={e => setFiltre(f => ({ ...f, durum: e.target.value }))}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Durumlar</option>
          <option value="aktif">Aktif</option>
          <option value="izleniyor">İzleniyor</option>
          <option value="kapandi">Kapandı</option>
        </select>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          {['yuksek', 'orta', 'dusuk'].map(s => {
            const c = riskler.filter(r => r.kalinti_seviye === s).length;
            const { bg, text, label } = SEV_RENK[s];
            return <span key={s} style={{ background: bg, color: text, padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
              {label}: {c}
            </span>;
          })}
        </div>
      </div>

      {/* Tablo */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead style={{ background: '#f9fafb' }}>
            <tr>
              {['Risk No', 'Risk Adı / Açıklama', 'Kategori / Düzey', 'Doğal Risk', 'Kalıntı Risk', 'Cevap', 'Sahip', 'İşlem'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {riskler.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>
                ℹ️ Henüz risk kaydı bulunmamaktadır. "Yeni Risk" butonu ile ekleyin.
              </td></tr>
            )}
            {riskler.map(r => {
              const ks = SEV_RENK[r.kalinti_seviye || ''];
              return (
                <tr key={r.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', fontFamily: 'monospace', color: '#374151', whiteSpace: 'nowrap' }}>{r.risk_no}</td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', maxWidth: 280 }}>
                    <div style={{ fontWeight: 600, color: '#111827', marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.risk_adi}</div>
                    <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.risk_aciklamasi}</div>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 11 }}>{r.risk_kategorisi || '-'}</div>
                    <div style={{ fontSize: 10, color: '#9ca3af' }}>
                      {r.risk_duzeyi === 'stratejik' ? '🏢 Stratejik' : r.risk_duzeyi === 'birim' ? '🏬 Birim' : '⚙️ Faaliyet'}
                    </div>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
                    <span style={{ background: pRenk(r.dogal_puan || 0), color: pYazi(r.dogal_puan || 0), padding: '2px 8px', borderRadius: 12, fontWeight: 700 }}>
                      {r.dogal_puan || 0}
                    </span>
                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>{r.dogal_olasilik}×{r.dogal_etki}</div>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
                    <span style={{ background: ks?.bg, color: ks?.text, padding: '2px 8px', borderRadius: 12, fontWeight: 700 }}>
                      {r.kalinti_puan || 0}
                    </span>
                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>{ks?.label}</div>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap', color: '#374151' }}>
                    {CEVAP_ETIKET[r.cevap_yontemi] || '-'}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: 12 }}>
                    {r.risk_sahibi_adi || '-'}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>
                    <button onClick={() => duzenle(r)} style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, marginRight: 6 }}>
                      Eylem
                    </button>
                    <button onClick={() => { setSecili(r); setForm({ ...r }); setModal('ekle'); }} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, marginRight: 6 }}>
                      Düzenle
                    </button>
                    <button onClick={() => riskSil(r.id)} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>
                      Sil
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ── Risk Ekle/Düzenle Modal ── */}
      {modal === 'ekle' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 780, maxHeight: '90vh', overflowY: 'auto', padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>{secili ? '✏️ Risk Düzenle' : '+ Yeni Risk Kaydı'}</h2>
              <button onClick={() => { setModal(''); setSecili(null); }} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#1e40af' }}>
              📋 <strong>6. Standart Şartı:</strong> Risklerin gerçekleşme olasılığı ve muhtemel etkileri yılda en az bir kez analiz edilmelidir.
              Risk puanı = Olasılık (1-10) × Etki (1-10)
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Alan label="Risk Adı *" span={2}>
                <input value={form.risk_adi} onChange={e => setForm(f => ({ ...f, risk_adi: e.target.value }))}
                  placeholder="Riskin açık ve net ifadesi..." style={girisSt()} />
              </Alan>
              <Alan label="Risk Açıklaması" span={2}>
                <textarea value={form.risk_aciklamasi} onChange={e => setForm(f => ({ ...f, risk_aciklamasi: e.target.value }))}
                  rows={2} placeholder="Riskin nasıl gerçekleşebileceği..." style={{ ...girisSt(), resize: 'vertical' }} />
              </Alan>
              <Alan label="İlgili Hedef">
                <input value={form.hedef_adi} onChange={e => setForm(f => ({ ...f, hedef_adi: e.target.value }))}
                  placeholder="Risk hangi hedefi etkiler?" style={girisSt()} />
              </Alan>
              <Alan label="Birim Adı">
                <input value={form.birim_adi} onChange={e => setForm(f => ({ ...f, birim_adi: e.target.value }))}
                  placeholder="İşletme / Birim" style={girisSt()} />
              </Alan>
              <Alan label="Risk Türü">
                <select value={form.risk_turu} onChange={e => setForm(f => ({ ...f, risk_turu: e.target.value }))} style={girisSt()}>
                  <option value="ic">İç Risk</option>
                  <option value="dis">Dış Risk</option>
                </select>
              </Alan>
              <Alan label="Risk Düzeyi">
                <select value={form.risk_duzeyi} onChange={e => setForm(f => ({ ...f, risk_duzeyi: e.target.value }))} style={girisSt()}>
                  <option value="stratejik">Stratejik</option>
                  <option value="birim">Birim</option>
                  <option value="faaliyet">Faaliyet</option>
                </select>
              </Alan>
              <Alan label="Risk Kategorisi">
                <select value={form.risk_kategorisi} onChange={e => setForm(f => ({ ...f, risk_kategorisi: e.target.value }))} style={girisSt()}>
                  <option value="mali">Mali</option>
                  <option value="operasyonel">Operasyonel</option>
                  <option value="stratejik">Stratejik</option>
                  <option value="uyum">Uyum / Mevzuat</option>
                  <option value="itibar">İtibar</option>
                  <option value="bilgi_teknoloji">Bilgi Teknolojisi</option>
                </select>
              </Alan>
              <Alan label="Risk Sahibi">
                <input value={form.risk_sahibi_adi} onChange={e => setForm(f => ({ ...f, risk_sahibi_adi: e.target.value }))}
                  placeholder="Ad Soyad / Unvan" style={girisSt()} />
              </Alan>
            </div>

            {/* Puanlama */}
            <div style={{ marginTop: 20, background: '#f9fafb', borderRadius: 10, padding: 16 }}>
              <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#111827' }}>📊 Risk Değerlendirmesi (Rehber EK 3 — Risk Kayıt Formu)</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                {/* Doğal Risk */}
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14 }}>
                  <div style={{ fontWeight: 600, marginBottom: 10, color: '#374151' }}>Doğal Risk (Önlem Öncesi)</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <Alan label={`Olasılık: ${form.dogal_olasilik}`}>
                      <input type="range" min={1} max={10} value={form.dogal_olasilik}
                        onChange={e => setForm(f => ({ ...f, dogal_olasilik: Number(e.target.value) }))} style={{ width: '100%' }} />
                    </Alan>
                    <Alan label={`Etki: ${form.dogal_etki}`}>
                      <input type="range" min={1} max={10} value={form.dogal_etki}
                        onChange={e => setForm(f => ({ ...f, dogal_etki: Number(e.target.value) }))} style={{ width: '100%' }} />
                    </Alan>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 8 }}>
                    <span style={{ background: pRenk(dogalPuan), color: pYazi(dogalPuan), padding: '4px 16px', borderRadius: 20, fontWeight: 800, fontSize: 18 }}>
                      {dogalPuan}
                    </span>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>
                      {dogalPuan >= 50 ? '🔴 Yüksek' : dogalPuan >= 25 ? '🟡 Orta' : '🟢 Düşük'}
                    </div>
                  </div>
                </div>

                {/* Kalıntı Risk */}
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14 }}>
                  <div style={{ fontWeight: 600, marginBottom: 10, color: '#374151' }}>Kalıntı Risk (Önlem Sonrası)</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <Alan label={`Olasılık: ${form.kalinti_olasilik}`}>
                      <input type="range" min={1} max={10} value={form.kalinti_olasilik}
                        onChange={e => setForm(f => ({ ...f, kalinti_olasilik: Number(e.target.value) }))} style={{ width: '100%' }} />
                    </Alan>
                    <Alan label={`Etki: ${form.kalinti_etki}`}>
                      <input type="range" min={1} max={10} value={form.kalinti_etki}
                        onChange={e => setForm(f => ({ ...f, kalinti_etki: Number(e.target.value) }))} style={{ width: '100%' }} />
                    </Alan>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 8 }}>
                    <span style={{ background: pRenk(kalintiPuan), color: pYazi(kalintiPuan), padding: '4px 16px', borderRadius: 20, fontWeight: 800, fontSize: 18 }}>
                      {kalintiPuan}
                    </span>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>
                      {kalintiPuan >= 50 ? '🔴 Yüksek' : kalintiPuan >= 25 ? '🟡 Orta' : '🟢 Düşük'}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mevcut Kontroller ve Cevap */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginTop: 14 }}>
              <Alan label="Mevcut Kontroller">
                <textarea value={form.mevcut_kontroller} onChange={e => setForm(f => ({ ...f, mevcut_kontroller: e.target.value }))}
                  rows={3} placeholder="Hâlihazırda uygulanan kontrol mekanizmaları..." style={{ ...girisSt(), resize: 'vertical' }} />
              </Alan>
              <div>
                <Alan label="Cevap Yöntemi">
                  <select value={form.cevap_yontemi} onChange={e => setForm(f => ({ ...f, cevap_yontemi: e.target.value }))} style={girisSt()}>
                    <option value="kabul_et">Kabul Et — Risk iştahı içinde</option>
                    <option value="kontrol_et">Kontrol Et — Kontrol faaliyeti ile yönet</option>
                    <option value="devret">Devret — Başka birime/kişiye devret</option>
                    <option value="kacin">Kaçın — Faaliyeti sonlandır/ertele</option>
                  </select>
                </Alan>
                <Alan label="Cevap Açıklaması">
                  <textarea value={form.cevap_aciklamasi} onChange={e => setForm(f => ({ ...f, cevap_aciklamasi: e.target.value }))}
                    rows={2} placeholder="Riskin nasıl yönetileceği..." style={{ ...girisSt(), resize: 'vertical' }} />
                </Alan>
              </div>
            </div>

            <Alan label="Notlar" span={2}>
              <textarea value={form.notlar} onChange={e => setForm(f => ({ ...f, notlar: e.target.value }))}
                rows={2} style={{ ...girisSt(), resize: 'vertical' }} />
            </Alan>

            <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end' }}>
              <button onClick={() => { setModal(''); setSecili(null); }} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                İptal
              </button>
              <button onClick={kaydet} disabled={kaydediliyor || !form.risk_adi} style={{
                padding: '10px 24px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                background: !form.risk_adi ? '#9ca3af' : '#1d4ed8', color: '#fff'
              }}>
                {kaydediliyor ? 'Kaydediliyor...' : secili ? 'Güncelle' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Eylem Planı Modal ── */}
      {modal === 'eylem' && secili && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 680, maxHeight: '90vh', overflowY: 'auto', padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>📋 Eylem Planı — {secili.risk_no}</h2>
              <button onClick={() => setModal('')} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>
            <div style={{ background: '#fef3c7', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#92400e', marginBottom: 16 }}>
              ⚠️ <strong>Risk:</strong> {secili.risk_adi} — Kalıntı Puan: <strong>{secili.kalinti_puan}</strong> ({SEV_RENK[secili.kalinti_seviye || '']?.label})
            </div>

            {/* Eylemler Listesi */}
            {eylemler.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af', background: '#f9fafb', borderRadius: 8, marginBottom: 16 }}>
                ℹ️ Henüz eylem planı oluşturulmamış.
              </div>
            ) : (
              <div style={{ marginBottom: 16 }}>
                {eylemler.map(e => (
                  <div key={e.id} style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, marginBottom: 8 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <strong style={{ fontSize: 13 }}>{e.eylem_adi}</strong>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>{e.durum}</span>
                    </div>
                    {e.aciklama && <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>{e.aciklama}</div>}
                    <div style={{ display: 'flex', gap: 12, fontSize: 11, color: '#9ca3af' }}>
                      {e.sorumlu_adi && <span>👤 {e.sorumlu_adi}</span>}
                      {e.bitis_tarihi && <span>📅 {new Date(e.bitis_tarihi).toLocaleDateString('tr-TR')}</span>}
                      <span>%{e.tamamlanma_yuzdesi}</span>
                    </div>
                    <div style={{ marginTop: 6, height: 6, background: '#e5e7eb', borderRadius: 3 }}>
                      <div style={{ height: '100%', width: `${e.tamamlanma_yuzdesi}%`, background: '#10b981', borderRadius: 3 }} />
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Yeni Eylem Formu */}
            <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14 }}>
              <h3 style={{ margin: '0 0 12px', fontSize: 14 }}>+ Yeni Eylem Ekle</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <Alan label="Eylem Adı" span={2}>
                  <input value={eylemForm.eylem_adi} onChange={e => setEylemForm(f => ({ ...f, eylem_adi: e.target.value }))}
                    placeholder="Alınacak önlem..." style={girisSt()} />
                </Alan>
                <Alan label="Sorumlu">
                  <input value={eylemForm.sorumlu_adi} onChange={e => setEylemForm(f => ({ ...f, sorumlu_adi: e.target.value }))}
                    placeholder="Ad Soyad" style={girisSt()} />
                </Alan>
                <Alan label="Bitiş Tarihi">
                  <input type="date" value={eylemForm.bitis_tarihi} onChange={e => setEylemForm(f => ({ ...f, bitis_tarihi: e.target.value }))} style={girisSt()} />
                </Alan>
                <Alan label={`Tamamlanma: %${eylemForm.tamamlanma_yuzdesi}`} span={2}>
                  <input type="range" min={0} max={100} value={eylemForm.tamamlanma_yuzdesi}
                    onChange={e => setEylemForm(f => ({ ...f, tamamlanma_yuzdesi: Number(e.target.value) }))} style={{ width: '100%' }} />
                </Alan>
              </div>
              <div style={{ textAlign: 'right', marginTop: 10 }}>
                <button onClick={eylemEkle} disabled={!eylemForm.eylem_adi} style={{
                  background: '#059669', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', cursor: 'pointer', fontWeight: 600
                }}>Eylem Ekle</button>
              </div>
            </div>

            <div style={{ textAlign: 'right', marginTop: 16 }}>
              <button onClick={() => setModal('')} style={{ padding: '10px 24px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Alan({ label, children, span }: { label: string; children: React.ReactNode; span?: number }) {
  return (
    <div style={{ gridColumn: span === 2 ? 'span 2' : 'span 1' }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{label}</label>
      {children}
    </div>
  );
}

function girisSt(): React.CSSProperties {
  return {
    width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8,
    fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#fff'
  };
}
